import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state:{
      copyOrder:{},
      qryOrderForm:{},
      user_category:{}
    },
    mutations:{
      copyOrderInfo(state,value){
        state.copyOrder = value;
      },
      clearOrderInfo(state){
        state.copyOrder={};
      },
      user_category(state,value){
        state.user_category = value;
      },
      clearUser_category(state){
        state.user_category={};
      },
      // 将订单列表页面的查询条件保存
      toDetailOrderNew(state,value){
        state.qryOrderForm = value;
      },
      // 清除订单列表页面的查询条件
      clearDetailOrderNew(state){
        state.qryOrderForm={};
      }
      
    },
    getters:{
        getOrderInfo(state){
            return state.copyOrder;
        },
        getToDetailOrderNew(state){
          return state.qryOrderForm;
        },
        getUser_category(state){
          return state.user_category;
        }
    }
  })


// WEBPACK FOOTER //
// ./src/store/store.js